module.exports = __webpack_public_path__ + "img/hero-image.cc7007c9.webp";